import { createApi } from '@reduxjs/toolkit/dist/query/react'
import baseQueryWithOnlineCourse from '../../app/baseQueryWithOnlineCourse'
import { ListResponse, PromocodeState, PaginationState, GeneralPromocodeState } from '../types'

export const promocodeApi = createApi({
    reducerPath: 'promocodeApi',
    baseQuery: baseQueryWithOnlineCourse,
    tagTypes: ['Promocode', 'GeneralPromocode'],
    endpoints: (build) => ({
        fetchAllPromocode: build.query<
            ListResponse<PromocodeState>,
            PaginationState
        >({
            query: (params) => ({
                url: `promocode`,
                method: 'GET',
                params,
            }),
            providesTags: (result) =>
                result
                    ? [
                          ...result.data.map(({ id }) => ({
                              type: 'Promocode' as const,
                              id,
                          })),
                          { type: 'Promocode', id: 'LIST' },
                      ]
                    : [{ type: 'Promocode', id: 'LIST' }],
            transformResponse: (response: {
                data: ListResponse<PromocodeState>
            }) => ({
                data: response.data.data,
                pageNumber: response.data.pageNumber,
                totalCount: response.data.totalCount,
                totalPages: response.data.totalPages,
            }),
        }),

        createPromocode: build.mutation<void, PromocodeState>({
            query: (promocode) => ({
                url: 'promocode/course',
                method: 'POST',
                body: promocode,
            }),
            invalidatesTags: [{ type: 'Promocode', id: 'LIST' }],
        }),

        updatePromocode: build.mutation<void, PromocodeState>({
            query: (promocode) => ({
                url: `promocode/${promocode.id}`,
                method: 'PUT',
                body: promocode,
            }),
            invalidatesTags: [{ type: 'Promocode', id: 'LIST' }],
        }),

        // deletePromocode: build.mutation<void, number>({
        //     query: (id) => ({
        //         url: `promocode/${id}`,
        //         method: 'DELETE',
        //     }),
        //     invalidatesTags: (result, error, id) => [{ type: 'Promocode', id }],
        // }),

        getExcelLinkOfPromocode: build.query<string, number>({
            query: (id) => ({
                url: `promocode/excel/${id}`,
            }),
            transformResponse: (response: any) => response.data,
        }),


        fetchAllGeneralPromocode: build.query<
            ListResponse<GeneralPromocodeState>,
            PaginationState
        >({
            query: (params) => ({
                url: `general-promocode`,
                method: 'GET',
                params,
            }),
            providesTags: (result) =>
                result
                    ? [
                          ...result.data.map(({ id }) => ({
                              type: 'GeneralPromocode' as const,
                              id,
                          })),
                          { type: 'GeneralPromocode', id: 'LIST' },
                      ]
                    : [{ type: 'GeneralPromocode', id: 'LIST' }],
            transformResponse: (response: {
                data: ListResponse<GeneralPromocodeState>
            }) => ({
                data: response.data.data,
                pageNumber: response.data.pageNumber,
                totalCount: response.data.totalCount,
                totalPages: response.data.totalPages,
            }),
        }),

        createGeneralPromocode: build.mutation<void, GeneralPromocodeState>({
            query: (promocode) => ({
                url: 'general-promocode',
                method: 'POST',
                body: promocode,
            }),
            invalidatesTags: [{ type: 'GeneralPromocode', id: 'LIST' }],
        }),

        deleteGeneralPromocode: build.mutation<void, number>({
            query: (id) => ({
                url: `general-promocode/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, id) => [{ type: 'GeneralPromocode', id }],
        }),
    }),
})
